import React from 'react';
import { styled } from '@linaria/react';

interface StatusBadgeProps {
    children: React.ReactNode;
    variant?: 'active' | 'inactive';
    size?: 'small' | 'medium' | 'large' | 'list';
    className?: string;
}

const StyledStatusBadge = styled.div<{ $variant: string; $size: string }>`
    font-size: ${(props) => {
        if (props.$size === 'list') return '0.5rem';
        if (props.$size === 'medium') return '0.7rem';
        return '0.875rem';
    }};
    padding: ${(props) => {
        if (props.$size === 'list') return '0.125rem 0.375rem';
        if (props.$size === 'medium') return '0.25rem 0.5rem';
        return '0.5rem 1rem';
    }};
    border-radius: ${(props) => (props.$size === 'list' ? '10px' : '20px')};
    font-weight: 600;
    text-align: center;
    min-width: ${(props) => (props.$size === 'list' ? '40px' : '60px')};
    display: inline-block;
    transition: all 0.2s ease;
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: 1px solid;

    background-color: ${(props) => (props.$variant === 'active' ? '#d4edda' : '#f8d7da')};
    color: ${(props) => (props.$variant === 'active' ? '#155724' : '#721c24')};
    border-color: ${(props) => (props.$variant === 'active' ? '#c3e6cb' : '#f5c6cb')};

    /* Large size adjustments */
    ${(props) =>
        props.$size === 'large'
            ? `
        font-weight: 600;
        letter-spacing: 0.5px;
        text-transform: uppercase;
    `
            : ''}
`;

export const StatusBadge = ({ variant = 'active', size = 'medium', className = '', children }: StatusBadgeProps) => {
    return (
        <StyledStatusBadge $variant={variant} $size={size} className={className}>
            {children}
        </StyledStatusBadge>
    );
};

export default StatusBadge;
